import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  getAllTickets,
  createAndupdateTickets,
} from "../../../apis/supportApi";
import TextInputFormik from "../../../lib/common/TextInputFormik";
import { supportSchema } from "../../../Validations/supportValidations";

export default function AddSupport() {
  const [loading, setLoading] = useState(false);
  const [editLoader, setEditLoader] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [addSupportInitial, setAddSupportInitial] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    query: "",
    ticketStatus: "",
  });
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      setIsReadOnly(true);
      editSupport(id);
    }
  }, [id]);

  const editSupport = async (id) => {
    setEditLoader(true);
    try {
      const res = await getAllTickets(id);
      if (res.result) {
        setAddSupportInitial({
          name: res.result.name,
          email: res.result.email,
          phoneNumber: res.result.phoneNumber,
          query: res.result.query,
          ticketStatus: res.result.ticketStatus,
        });
      }
    } catch (error) {
      console.error("Error fetching Support:", error);
    } finally {
      setEditLoader(false);
    }
  };

  const formik = useFormik({
    initialValues: addSupportInitial,
    enableReinitialize: true,
    validationSchema: supportSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        let res;
        id
          ? (res = await createAndupdateTickets(id, values))
          : await createAndupdateTickets(null, {
              ...values,
              type: "SupportTeam",
            });
        setLoading(false);
        formik.resetForm();
        navigate("/support");
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
  });

  const backClick = () => navigate("/support");

  return (
    <div className="main-wrapper">
      <div className="page-wrapper">
        <div className="content container-fluid">
          <i
            className="fas fa-arrow-left"
            style={{ marginRight: "30px", fontSize: "20px" }}
            onClick={backClick}
          />
          <div className="my-3 p-3 bg-body rounded shadow-sm">
            {editLoader ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "50px" }}
              >
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                <TextInputFormik
                  label="Title"
                  field="name"
                  formik={formik}
                  readOnly={id ? isReadOnly : false}
                />

                <TextInputFormik
                  type="email"
                  label="Email"
                  field="email"
                  formik={formik}
                  readOnly={id ? isReadOnly : false}
                />

                <TextInputFormik
                  label="Phone Number"
                  field="phoneNumber"
                  formik={formik}
                  readOnly={id ? isReadOnly : false}
                />

                <TextInputFormik
                  label="Query"
                  field="query"
                  formik={formik}
                  readOnly={id ? isReadOnly : false}
                />

                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Ticket Status <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="ticketStatus"
                    value={formik.values.ticketStatus}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={
                      id && formik.values.ticketStatus === "Closed"
                        ? true
                        : false
                    }
                  >
                    <option value="">Select Status</option>
                    <option value="Created">Created</option>
                    <option value="Closed">Closed</option>
                  </select>
                  {formik?.errors?.ticketStatus &&
                    formik?.touched?.ticketStatus && (
                      <span className="text-danger">
                        {formik.errors.ticketStatus}
                      </span>
                    )}
                </div>

                {!isReadOnly && (
                  <button className="btn btn-primary" type="submit">
                    {id ? "Update" : "Submit"}
                  </button>
                )}
                {isReadOnly && (
                  <button className="btn btn-primary" type="submit">
                    Update Ticket Status
                  </button>
                )}
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
